import {ONT_STATUS_TYPES, OntMetadata, OntStatusTypes, ProductInstance, STATUS_TYPES, StatusTypes} from "../../../util/types.ts";
import {useEffect, useState} from "react";
import {getOntStatus} from "../../../util/request.ts";
import LoaderSpinner from "../../loaders/LoaderSpinner.tsx";
import Icon from "../Icon.tsx";
import IconCheck from "../../icons/IconCheck.tsx";
import IconCross from "../../icons/IconCross.tsx";
import IconMediaconverterStroke from "../../icons/IconMediaconverterStroke.tsx";
import IconQuestion from "../../icons/IconQuestion.tsx";

export default function Ont({customer_id, product_instance, setOntStatus, setMac}: {
    customer_id: string,
    product_instance: ProductInstance,
    setOntStatus: React.Dispatch<React.SetStateAction<OntStatusTypes | undefined>>;
    setMac: React.Dispatch<React.SetStateAction<string|undefined>>;
}) {
    const [ont, setOnt] = useState<OntMetadata>();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    useEffect(() => {
        getOntStatus(customer_id, product_instance.parent_product_instance_id)
            .then((r) => {
                if (r.code !== 200 || r.response.data?.result === 'FAIL') {
                    setError('Vi kan ikke hente data for din fiberboks lige nu. Prøv igen senere.')
                    setOntStatus(ONT_STATUS_TYPES.fail)
                    return;
                }

                setOnt(r.response.data);
                setMac(r.response.data.mac_address);
                setOntStatus(getOntStatusState(r.response.data));
            })
            .catch(() => {
                setError('Vi kan ikke hente data for din fiberboks lige nu. Prøv igen senere.')
                setOntStatus(ONT_STATUS_TYPES.fail)
                setMac('')
            })
            .finally(() => setLoading(false));
    }, [customer_id, product_instance.parent_product_instance_id, setOntStatus, setMac]);

    if (loading) {
        return <div className={'device-container device-container--ont'}>
            <div className={'device'}>
                <Icon component={IconMediaconverterStroke}/>
                <p>Fiberboks</p>
            </div>
            <div className={'line'}/>
            <div className={'status-icon'}>
                <LoaderSpinner/>
            </div>
            <div className={'line'}/>
        </div>;
    }
    if (error || !ont) {
        return <div className={'device-container device-container--ont'}>
            <div className={'device'}>
                <Icon component={IconMediaconverterStroke}/>
                <p>Fiberboks</p>
            </div>
            <div className={'line'}/>
            <div className={'status-icon'}>
                <Icon component={IconQuestion} className={'status-black'}/>
            </div>
            <div className={'line'}/>
        </div>;
    }

    const statusColor = getOntStatusColor(ont);

    return <div className={'device-container device-container--ont'}>
        <div className={'device'}>
            <Icon component={IconMediaconverterStroke}/>
            <p>Fiberboks</p>
        </div>
        <div className={'line'}/>
        <div className={'status-icon'}>
            {loading ? (
                <LoaderSpinner/>
            ) : (<>
                {statusColor === STATUS_TYPES.green && <Icon component={IconCheck} className={`status-${statusColor}`}/>}
                {statusColor === STATUS_TYPES.red && <Icon component={IconCross} className={`status-${statusColor}`}/>}
            </>)}
        </div>
        <div className={'line'}/>
    </div>
}

function getOntStatusColor(ont: OntMetadata): StatusTypes {
    if (ont.link_state === 'Up') {
        return STATUS_TYPES.green;
    }

    if (ont.link_state === 'Down') {
        return STATUS_TYPES.red;
    }

    if (ont.mac_address === '') {
        return STATUS_TYPES.red;
    }

    return STATUS_TYPES.red;
}

function getOntStatusState(ont: OntMetadata): OntStatusTypes {
    if (ont.link_state === 'Up') {
        return ONT_STATUS_TYPES.up;
    }

    return ONT_STATUS_TYPES.down;
}
